export const loadPageComponent = page =>
  import(
    /* webpackChunkName: "chunk-[request][index]" */
    /* webpackInclude: /\.js/ */
    /* webpackExclude: /__tests__|components|assets/ */
    `../pages/${page}`
  )
